export type SafetyStatusType =
  | 'پرریسک'
  | 'نیازمند توجه'
  | 'نسبتاً ایمن'
  | 'ایمن'
  | 'داده ناکافی برای ارزیابی'
  | string;

export interface SafetyRootResponse {
  Table?: SafetySummary[];       // خلاصه ناوگان (تک ردیف)
  Table1?: StatusCount[];        // توزیع وضعیت ایمنی
  Table2?: TopRiskVehicle[];     // خودروهای بحرانی (سبک، آماده نمودار)
  Table3?: RiskAverages[];       // میانگین مؤلفه‌های ریسک (تک ردیف)
  Table4?: SpeedStatistics[];    // آمار سرعت کل ناوگان (تک ردیف)
  Table5?: TopSpeedVehicle[];    // خودروهای با بیشترین سرعت (جدول تب سرعت)
  Table6?: EventsPer50Km[];      // نرخ رویداد در ۵۰ کیلومتر (تک ردیف)
  Table7?: DataQualityStats[];   // آمار کیفیت داده (تک ردیف)
  Table8?: VehicleSafetyDetail[];// جزئیات کامل هر خودرو (تب جدول)
}

/** Table — خلاصه ناوگان */
export interface SafetySummary {
  TotalVehicles: number;
  AvgSafetyScore: number;
  TotalDistanceKm: number;
  TotalEvents: number;
  VeryHighRiskEvents: number;
  HighRiskVehicles: number;
  NeedAttentionVehicles: number;
  CriticalWarningVehicles: number;
  InsufficientDataVehicles: number;
  LowQualityVehicles: number;
}

/** Table1 — توزیع وضعیت */
export interface StatusCount {
  SafetyStatus: string;
  VehicleCount: number;
}

/** Table2 — خودروی بحرانی  */
export interface TopRiskVehicle {
  strUnitID: string;
  strFullName: string;
  strVehicleNo: string;
  DistanceKm: number;
  DrivingMinutes: number;
  MaxSpeed: number;
  SafetyScore: number;
  TotalRisk: number;
  HighSpeedRisk: number;
  DecelerationRisk: number;
  AccelerationRisk: number;
  RepetitionRisk: number;
  DrivingPatternRisk: number;
  SafetyStatus: string;
  MainWarning: string;
}

/** Table3 — میانگین ریسک‌ها */
export interface RiskAverages {
  AvgHighSpeedRisk: number;
  AvgDecelerationRisk: number;
  AvgAccelerationRisk: number;
  AvgRepetitionRisk: number;
  AvgDrivingPatternRisk: number;
  AvgTotalRisk: number;
}

/** Table4 — آمار سرعت */
export interface SpeedStatistics {
  TotalSpeed80Seconds: number;
  TotalSpeed100Seconds: number;
  TotalSpeed110Seconds: number;
  TotalSpeed120Seconds: number;
  AvgSpeed80Seconds: number;
  AvgSpeed100Seconds: number;
  AvgSpeed110Seconds: number;
  AvgSpeed120Seconds: number;
  PeakSpeedSamples140: number;
  PeakSpeedSamples160: number;
  PeakSpeedSamples180: number;
  PeakSpeedSamples200: number;
  PeakSpeedDuration160: number;
  PeakSpeedDuration180: number;
  FleetMaxSpeed: number;
}

/** Table5 — ریسک به تفکیک وضعیت */
export interface RiskByStatus {
  SafetyStatus: string;
  AvgTotalRisk: number;
  VehicleCount?: number;
}

/** Table5 — خودروهای با بیشترین مدت سرعت  */
export interface TopSpeedVehicle {
  strUnitID: string;
  strFullName: string;
  strVehicleNo: string;
  MaxSpeed: number;
  Speed80Seconds: number;
  Speed100Seconds: number;
  Speed110Seconds: number;
  Speed120Seconds: number;
  PeakSpeedConfidence: number;
  PeakSpeedSamples140: number;
  PeakSpeedSamples160: number;
  PeakSpeedSamples180: number;
  PeakSpeedSamples200: number;
  PeakSpeedDuration160: number;
  PeakSpeedDuration180: number;
  SafetyScore: number;
  SafetyStatus: string;
}

/** Table6 — نرخ رویداد */
export interface EventsPer50Km {
  AccelerationEventsPer50Km: number;
  DecelerationEventsPer50Km: number;
  VeryHighRiskEventsPer50Km: number;
}

/** Table7 — کیفیت داده */
export interface DataQualityStats {
  TotalVehicles: number;
  GoodQualityVehicles: number;
  LowQualityVehicles: number;
  PeakConfidence0To30: number;
  PeakConfidence31To60: number;
  PeakConfidence61To89: number;
  PeakConfidence90To100: number;
  DistanceConfidence0To49: number;
  DistanceConfidence50To79: number;
  DistanceConfidence80To100: number;
}

/** Table8 — ردیف کامل هر خودرو */
export interface VehicleSafetyDetail {
  strUnitID: string;
  strFullName: string;
  strVehicleNo: string;
  DistanceKm: number;
  DrivingMinutes: number;
  MaxSpeed: number;
  TotalEvents: number;
  AccelerationEvents: number;
  DecelerationEvents: number;
  AvgAccelerationRisk: number;
  AvgDecelerationRisk: number;
  HighRiskEvents: number;
  VeryHighRiskEvents: number;
  InstantAccelerationEvents: number;
  InstantDecelerationEvents: number;
  VerySuddenAccelerationEvents: number;
  VerySuddenDecelerationEvents: number;
  Speed80Seconds: number;
  Speed100Seconds: number;
  Speed110Seconds: number;
  Speed120Seconds: number;
  HighSpeedRisk: number;
  DecelerationRisk: number;
  AccelerationRisk: number;
  RepetitionRisk: number;
  DrivingPatternRisk: number;
  AccelerationEventsPer50Km: number;
  DecelerationEventsPer50Km: number;
  VeryHighRiskEventsPer50Km: number;
  PeakSpeedConfidence: number;
  PeakSpeedRisk: number;
  PeakSpeedSamples140: number;
  PeakSpeedSamples160: number;
  PeakSpeedSamples180: number;
  PeakSpeedSamples200: number;
  PeakSpeedDuration160: number;
  PeakSpeedDuration180: number;
  DistanceConfidence: number;
  TotalRisk: number;
  SafetyScore: number;
  SafetyStatus: string;
  MainWarning: string;
  DataQuality: string;
}

export interface SafetyDashboardPayload {
  summary: SafetySummary | null;
  statusDistribution: StatusCount[];
  topRiskVehicles: TopRiskVehicle[];
  riskAverages: RiskAverages | null;
  speedStatistics: SpeedStatistics | null;
  topSpeedVehicles: TopSpeedVehicle[];
  riskByStatus: RiskByStatus[];
  eventsPer50Km: EventsPer50Km | null;
  dataQuality: DataQualityStats | null;
  vehicles: VehicleSafetyDetail[];
}

export type SafetyScoreItem = VehicleSafetyDetail;

export const EMPTY_PAYLOAD: SafetyDashboardPayload = {
  summary: null,
  statusDistribution: [],
  topRiskVehicles: [],
  riskAverages: null,
  speedStatistics: null,
  topSpeedVehicles: [],
  riskByStatus: [],
  eventsPer50Km: null,
  dataQuality: null,
  vehicles: [],
};

export const SAFETY_STATUS_COLORS: Record<string, string> = {
  'پرریسک': '#ff5d68',
  'نیازمند توجه': '#ff9b54',
  'نسبتاً ایمن': '#f5c451',
  'ایمن': '#35d07f',
  'داده ناکافی برای ارزیابی': '#647889',
};

export const RISK_KEYS: { key: keyof RiskAverages; label: string; vehicleKey: string }[] = [
  { key: 'AvgHighSpeedRisk', label: 'ریسک سرعت بالا', vehicleKey: 'HighSpeedRisk' },
  { key: 'AvgDecelerationRisk', label: 'ریسک کاهش سرعت', vehicleKey: 'DecelerationRisk' },
  { key: 'AvgAccelerationRisk', label: 'ریسک شتاب‌گیری', vehicleKey: 'AccelerationRisk' },
  { key: 'AvgRepetitionRisk', label: 'ریسک تکرار رفتار', vehicleKey: 'RepetitionRisk' },
  { key: 'AvgDrivingPatternRisk', label: 'ریسک الگوی رانندگی', vehicleKey: 'DrivingPatternRisk' },
];
